import type { FormField } from '@cli-types/core-engine/schema.js'
import { SAMPLE_UUID } from '@cli-constants/generators.js'
import { createFormInputObject } from './create-form-input-object.js'
export function createFormSubmissionObject(fields: FormField[]): Record<string, unknown> {
  return {
    id: SAMPLE_UUID,
    ...createFormInputObject(fields),
    ipAddress: '127.0.0.1',
    userAgent: 'Mozilla/5.0',
    submittedAt: '2026-01-01T00:00:00.000Z',
    createdAt: '2026-01-01T00:00:00.000Z',
    updatedAt: '2026-01-01T00:00:00.000Z'
  }
}
